import { InjectionToken } from '@angular/core';

export interface MediaFileEntry {
  name: string;
  size: number;
  isDirectory: boolean;
}

export interface MediaTransferProgress {
  bytes: number;
  contentLength: number;
  elapsedMs: number;
  mbPerSecAvg: number;
  mbPerSecWindow: number;
}

export interface MediaTransport {
  list$(remoteDir: string): Promise<Array<MediaFileEntry>>;
  size$(remotePath: string): Promise<number>;
  // onProgress fires at most every 200ms; a final call at completion is not guaranteed.
  downloadToFile$(remotePath: string, localPath: string, onProgress?: (progress: MediaTransferProgress) => void): Promise<void>;
  // Fast pre-flight so a sync cycle can fail immediately with a distinct reason instead of hanging into the request timeout.
  isReachable$(): Promise<boolean>;
}

export const MEDIA_TRANSPORT = new InjectionToken<MediaTransport>('MediaTransport');
